import { z } from 'zod';

import type { IdAccountTypeDto, IdContactDto, IdIndustryDto, IndustryDto } from '@/services/ws-crm/src/main/resources/rest-api';
import type { IdLabelDto } from '@/services/ws-labels/src/main/resources/rest-api';

import type { Option } from 'src/types';

export enum AccountsListSearchKey {
  SEARCH = 'search',
  INCLUDE_INACTIVE = 'includeInactive',
  INDUSTRY = 'industry',
  SALES = 'sales',
  LABELS = 'labels',
  ROLES = 'roles',
}

export const AccountsListSearchParams = z.object({
  [AccountsListSearchKey.SEARCH]: z.string().optional(),
  [AccountsListSearchKey.INCLUDE_INACTIVE]: z.custom<boolean>().optional(),
  [AccountsListSearchKey.INDUSTRY]: z.custom<IdIndustryDto>().optional(),
  [AccountsListSearchKey.SALES]: z.custom<IdContactDto>().optional(),
  [AccountsListSearchKey.LABELS]: z.array(z.custom<IdLabelDto>()).optional(),
  [AccountsListSearchKey.ROLES]: z.array(z.custom<string>()).optional(),
});

export type AccountsListSearchParams = z.infer<typeof AccountsListSearchParams>;

export type FiltersState = {
  search: string;
  includeInactive: boolean;
  industry: Option<IndustryDto> | null;
  sales: Option<IdContactDto> | null;
  labels: Option<IdLabelDto>[];
  roles: Option<string>[];
  hasActiveRevenue: boolean;
  accountType: Option<IdAccountTypeDto> | null;
};
